export default "__VITE_ASSET__CYvm7KqD__"